export default __webpack_public_path__ + "static/media/elektronik.94175e9e.png";